// [CurveBeam] - [BoneVue]

import dicomImageLoader from '@cornerstonejs/dicom-image-loader';
import { DicomMetadataStore, ServicesManager } from '@ohif/core';
import { getLast } from './getLast';

const index = 0;

/**
 * Load DICOM file from S3 to cornerstone
 * @param servicesManager
 * @param url S3 URL
 * @returns Loaded displaySetInstanceUID
 */
export async function loadS3DicomFile(
  servicesManager: ServicesManager,
  url: string,
): Promise<string> {
  const { displaySetService } = servicesManager.services;

  const loader = dicomImageLoader.wadouri.getLoaderForScheme('dicomweb');
  const dataset = await dicomImageLoader.wadouri.dataSetCacheManager.load(
    url,
    loader,
    `dicomfile:${index}`,
  );

  const newData = dataset.byteArray.buffer;
  const study = DicomMetadataStore.addInstance(newData);
  const series = getLast(study.series);
  const instance = getLast(series.instances);
  instance['url'] = `dicomweb:${url}`;

  const StudyInstanceUID = study.StudyInstanceUID;
  const SeriesInstanceUID = series.SeriesInstanceUID;

  const seriesMetadata = DicomMetadataStore.getSeries(StudyInstanceUID, SeriesInstanceUID);
  const displaySetsAdded = displaySetService.makeDisplaySets(seriesMetadata.instances, {
    madeInClient: false,
  });

  const displaySetAdded = getLast(displaySetsAdded);
  return displaySetAdded.displaySetInstanceUID;
}
